export default "__VITE_ASSET__3de1160f__"